import { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { useDispatch, useSelector } from 'react-redux';

import { ComponentLoader } from 'components/index';
import fetch from 'features/common/fetch';
import { fetchLeadsSummary } from 'features/views/dashboard/statistics/actions';
import { getSellectedSeller } from 'features/views/dashboard/statistics/selectors';

import LeadsFromMarketPlace from './LeadsFromMarketPlace';
import LeadsOutOfMarketPlace from './LeadsOutOfMarketPlace';

export const LeadsBar = () => {
	const dispatch = useDispatch();
	const selectedSeller = useSelector(getSellectedSeller);

	useEffect(() => {
		dispatch(fetchLeadsSummary(selectedSeller));
	}, [dispatch, selectedSeller]);

	return (
		<Grid container>
			<Grid size={12}>
				<Grid container spacing={2}>
					<Grid
						size={{
							xs: 12,
							xl: 6,
						}}
					>
						<ComponentLoader fetchStorePath={fetch.constants.urls.leadsSummary} forceInlineError>
							<Paper
								sx={{
									p: 3,
									backgroundColor: (theme) => theme.palette.background[100],
									borderRadius: 1,
								}}
							>
								<LeadsFromMarketPlace />
							</Paper>
						</ComponentLoader>
					</Grid>
					<Grid
						size={{
							xs: 12,
							xl: 6,
						}}
					>
						<ComponentLoader fetchStorePath={fetch.constants.urls.leadsSummary} forceInlineError>
							<Paper
								sx={{
									p: 3,
									backgroundColor: (theme) => theme.palette.background[100],
									borderRadius: 1,
								}}
							>
								<LeadsOutOfMarketPlace />
							</Paper>
						</ComponentLoader>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default LeadsBar;
